// Mirrors src/Domain/Constants/Permissions.cs — values must match the backend exactly.
export const PERMISSIONS = Object.freeze({
  EQUIPMENT_VIEW: 'Equipment.View',
  EQUIPMENT_EDIT: 'Equipment.Edit',
  HBELS_VIEW: 'Hbels.View',
  HBELS_EDIT: 'Hbels.Edit',
  PRODUCTS_VIEW: 'Products.View',
  PRODUCTS_EDIT: 'Products.Edit',
  ANALYTICAL_METHODS_VIEW: 'AnalyticalMethods.View',
  ANALYTICAL_METHODS_EDIT: 'AnalyticalMethods.Edit',
  CLEANING_AGENTS_VIEW: 'CleaningAgents.View',
  CLEANING_AGENTS_EDIT: 'CleaningAgents.Edit',
  DOCUMENTS_VIEW: 'Documents.View',
  DOCUMENTS_EDIT: 'Documents.Edit',
  FMECA_VIEW: 'Fmeca.View',
  FMECA_EDIT: 'Fmeca.Edit',
  FMECA_REVIEW: 'Fmeca.Review',
  NPA_VIEW: 'Npa.View',
  NPA_EDIT: 'Npa.Edit',
  NPA_REVIEW: 'Npa.Review',
  PROTOCOL_VIEW: 'Protocol.View',
  PROTOCOL_EDIT: 'Protocol.Edit',
  PROTOCOL_REVIEW: 'Protocol.Review',
  PROTOCOL_EXECUTE: 'Protocol.Execute',
  RISK_REGISTER_VIEW: 'RiskRegister.View',
  RISK_REGISTER_EDIT: 'RiskRegister.Edit',
  TEAM_EDIT: 'Team.Edit',
  ROLES_EDIT: 'Roles.Edit',
  SETTINGS_EDIT: 'Settings.Edit',
  EMAIL_TEMPLATE_EDIT: 'EmailTemplate.Edit',
  AUDIT_VIEW: 'Audit.View',
});
